export default from './video-embed';



// WEBPACK FOOTER //
// ./app/components/video-embed/index.js